import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


const apiKey = process.env.REACT_APP_API_KEY;
const apiUrl = process.env.REACT_APP_API_PATH;

const News = () => {
    const [noticias, setNoticias] = React.useState([]);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        variableWidth: true,
    };

    React.useEffect(() => {
        const getNoticias = async () => {
            try {

                const custom_headers = new Headers();
                custom_headers.append('x-api-key', `${apiKey}`);
                custom_headers.append('Content-Type', 'application/json');

                const requestOptions = {
                    method: 'GET',
                    headers: custom_headers,
                    redirect: 'follow'
                };

                const response = await fetch(`${apiUrl}/api/noticias`, requestOptions);
                const result = await response.json();

                if(result.error) {
                    console.log(result.error);
                    return;
                }

                setNoticias(result);
                console.log(result);
            } catch (error) {
                console.log(error.message);
            }
        };

        getNoticias();
    }, []);

    return (
        <section id="noticias" className="section vertical noticias">
            <Container>
                <Row>
                    <h1 className='heading1'>
                        Noticias
                    </h1>
                </Row>
                <Row className="contenido">
                    <div className='slick-container'>
                        <Slider {...settings}>
                            {noticias.map((noticia, index) => (
                                <Col key={index} lg={3} md={3} sm={6} xs={12} className="mb-3">
                                    <Card style={{ width: '300px', marginRight: '20px' }}>
                                    <Card.Img variant="top" src={noticia.IMAGEN} style={{ width: '298px', height: '198px', objectFit: 'cover' }} />
                                        <Card.Body>
                                            <Card.Text>
                                                <small style={{ fontWeight: 'bold' }}>{new Date(noticia.FECHA_HORA).toLocaleDateString('en-CA')}</small><br/>
                                                {noticia.CONTENIDO}<br/>
                                                <a href={noticia.LINK} target='_blank' rel='noreferrer'>
                                                    Leer más
                                                </a>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Slider>
                    </div>
                </Row>
            </Container>
        </section>
    );
};

export default News;